import Vue from 'vue'
import Confirm from './confirm'
import YyghConfirmInformation from './yygh-confirm-information'
import YyghModifyAddressOrMobile from './yygh-modify-address-or-mobile'
import YyghBindSuccess from './yygh-bind-success'
import DsJcjy from './ds-jcjy'
import DsToPicc from './ds-to-picc'
import DsShowShoushu from './ds-show-shoushu'
import DsNewsDetail from './ds-news-detail'
import DsTodo from './ds-todo'
import UserKefu from '@/plugins/user/kefu'
import KefuCall from './kefu-call'
import UploadScan from './upload-scan'
import NcpKslistConfirm from "@/plugins/dialog/ncp-kslist-confirm";
import Kefu from "@/plugins/dialog/kefu";
import Picker from "@/plugins/dialog/picker";
import MulPicScan from "@/plugins/dialog/mul-pic-scan";
import DhJcjy from "@/plugins/dialog/dh-jcjy";
import DhSelectHos from "@/plugins/dialog/dh-select-hos";
import DhDzd from "@/plugins/dialog/dh-dzd";
import CommonErrorDialog from "@/plugins/dialog/common-error-dialog.vue";

const body = document.querySelector('body');

function factory(Com) {
  console.log('----Com配置对象----', Com)
  const Comc = Vue.extend(Com);
  const com = new Comc();
  console.log('----com实例----', com)
  window.addEventListener('hashchange', () => {
    com && com.$el && body.contains(com.$el) && body.removeChild(com.$el);
    com && com.$destroy();
  })
  com.$mount();
  return com;
}

/**
 * 一般 confirm 弹窗
 * @param options
 * @param options.title
 * @param options.message
 * @param options.icon
 * @param options.confirmBtnText
 * @param options.cancelBtnText
 * @returns {Promise<unknown>}
 */
function confirm(options) {
  return new Promise((resolve, reject) => {
    const c = factory(Confirm);
    body.appendChild(c.$el);

    if (options.title) {
      c.title = options.title;
    }
    if (options.message) {
      c.message = options.message;
    }
    if (options.icon) {
      c.icon = options.icon;
    }
    if (options.confirmBtnText) {
      c.confirmBtnText = options.confirmBtnText;
    }
    if (options.cancelBtnText) c.cancelBtnText = options.cancelBtnText;


    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 一般错误信息弹窗
 * @param options
 * @param options.title
 * @param options.message
 * @param options.confirmBtnText
 * @returns {Promise<unknown>}
 */
function commonErrorDialog(options) {
  return new Promise((resolve, reject) => {
    const c = factory(CommonErrorDialog);
    body.appendChild(c.$el);
    if (options.title) {
      c.title = options.title;
    }
    if (options.message) {
      c.message = options.message;
    }

    if (options.confirmBtnText) {
      c.confirmBtnText = options.confirmBtnText;
    }

    c.$on('closed', () => {
      body.contains(c.$el) && body.removeChild(c.$el);
      c && c.$destroy();
    });

    c.$on('confirm', () => {
      resolve(true);
    })

    c.open();
  })
}

/**
 * 预约挂号确认地址和预留手机号信息
 * @param options
 * @param options.name
 * @param options.mobile
 * @param options.address
 * @returns {Promise<unknown>}
 */
function yyghConfirmInformation(options) {
  return new Promise((resolve, reject) => {
    const c = factory(YyghConfirmInformation);
    body.appendChild(c.$el);

    ['name', 'address', 'mobile'].forEach(item => {
      if (options[item]) c[item] = options[item];
    })

    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 信息不全-弹窗
 * @param options
 * @param options.message
 * @param options.addressBtnText
 * @param options.mobileBtnText
 * @returns {Promise<unknown>}
 */
function yyghModifyAddressOrMobile(options) {
  return new Promise((resolve, reject) => {
    const c = factory(YyghModifyAddressOrMobile);
    body.appendChild(c.$el);

    ['message', 'addressBtnText', 'mobileBtnText'].forEach(key => {
      if (options[key]) c[key] = options[key];
    })


    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 绑定成功弹窗
 * @param options
 * @param options.code
 * @returns {Promise<unknown>}
 */
function yyghBindSuccess(options) {
  return new Promise((resolve, reject) => {
    const c = factory(YyghBindSuccess);
    body.appendChild(c.$el);

    ['code'].forEach(key => {
      if (options[key]) c[key] = options[key];
    })


    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 日间手术-查看安排的检验检查
 * @param options
 * @returns {Promise<unknown>}
 */
function dsJcjy(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DsJcjy);
    body.appendChild(c.$el);

    ['jcList', 'jyList'].forEach(r => {
      c[r] = options[r];
    });

    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 等候入院-查看安排的检验检查
 * @param options
 * @returns {Promise<unknown>}
 */
function dhJcjy(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DhJcjy);
    body.appendChild(c.$el);

    c.$on('closed', (type, list) => {
      if (type === 'confirm') resolve(list)
      else reject();
    })

    c.dwcList = options.dwcList;
    c.allList = options.allList;

    c.open();
  })
}

/**
 * 等候入院-查看安排的检验检查
 * @param options
 * @returns {Promise<unknown>}
 */
function dhSelectHos(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DhSelectHos);
    body.appendChild(c.$el);

    c.$on('closed', (type, data) => {
      if (type === 'confirm') resolve(data)
      else reject();
    })

    c.allList = options.allList;

    c.open();
  })
}

/**
 * 等候入院-导诊单
 * @param options
 * @returns {Promise<unknown>}
 */
function dhDzd(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DhDzd);
    body.appendChild(c.$el);

    c.$on('closed', (type) => {
      if (type === 'confirm') resolve()
      else reject();
    })

    c.allList = options.allList;
    c.open();
  })
}

/**
 * 日间手术-我要投保
 * @param options
 * @returns {Promise<unknown>}
 */
function dsToPicc(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DsToPicc);
    body.appendChild(c.$el);


    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 日间手术-显示手术进度
 * @param options
 * @returns {Promise<unknown>}
 */
function dsShowShoushu(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DsShowShoushu);
    body.appendChild(c.$el);

    ['state'].forEach(r => {
      c[r] = options[r];
    })

    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 日间手术-新闻详情
 * @param options
 * @returns {Promise<unknown>}
 */
function dsNewsDetail(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DsNewsDetail);
    body.appendChild(c.$el);

    ['title', 'message'].forEach(r => {
      if (options[r])
        c[r] = options[r];
    })


    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 日间手术-我要做日间手术
 * @param options
 * @returns {Promise<unknown>}
 */
function dsTodo(options) {
  return new Promise((resolve, reject) => {
    const c = factory(DsTodo);
    body.appendChild(c.$el);

    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 新版联系客服
 * @param options
 * @returns {Promise<unknown>}
 */
function kefuCall(options = {}) {
  return new Promise((resolve, reject) => {
    const c = factory(KefuCall);
    body.appendChild(c.$el);

    ['tel'].forEach(r => {
      if (options[r]) c[r] = options[r];
    });

    c.remove = function (type) {
      body.removeChild(c.$el);
      if (type === 'cancel') reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 老版联系客服
 * @returns {Promise<unknown>}
 */
function userkefu() {
  return new Promise((resolve, reject) => {
    const c = factory(UserKefu);
    c.show();
  })
}

/**
 * 上传预览
 * @returns {Promise<unknown>}
 */
function uploadScan(files) {
  return new Promise((resolve, reject) => {
    const c = factory(UploadScan);
    body.appendChild(c.$el);
    c.files = files;
    c.remove = function (type) {
      body.removeChild(c.$el);
      if (!type) reject({type});
      else resolve({type});
    }
    c.open();
  })
}

/**
 * 核酸开单多订单提示
 * @param list
 * @returns {Promise<unknown>}
 */
function ncpKdlistConfirm(list) {
  return new Promise((resolve, reject) => {
    const component = factory(NcpKslistConfirm);
    component.$on('closed', type => {
      body.removeChild(component.$el);
      if (type === 'confirm') resolve()
      else reject();
      component.$destroy();
    });
    body.appendChild(component.$el);
    component.kdList = list;


    component.open();
  })
}

/**
 * 通用联系我们
 * @returns {Promise<unknown>}
 */
function kefu(options) {
  return new Promise((resolve, reject) => {
    const component = factory(Kefu);

    component.workTime = options.workTime;
    component.workPm = options.workPm;
    component.workAm = options.workAm;
    component.mobile = options.mobile;

    body.appendChild(component.$el);
    component.open();
  })
}

function picker(options) {
  return new Promise((resolve, reject) => {
    const component = factory(Picker);

    component.$on('confirm', (value, index) => {
      Log('value-index', value, index);
      resolve({value, index});
    })

    component.columns = options.columns;

    body.appendChild(component.$el);
    component.open();
  })
}

function mulPicScan(options) {
  return new Promise((resolve, reject) => {
    const component = factory(MulPicScan);

    component.$on('send', pics => {
      resolve(pics);
    })
    component.$on('hide', () => reject())
    component.files = options.files;

    body.appendChild(component.$el);
    component.open();
  })
}


export default {
  install(Vue, options) {
    Vue.prototype.$zhe2dialog = {
      confirm,
      commonErrorDialog,
      yyghConfirmInformation,
      yyghModifyAddressOrMobile,
      yyghBindSuccess,
      dsJcjy,
      dhJcjy,
      dhSelectHos,
      dhDzd,
      dsToPicc,
      dsShowShoushu,
      dsNewsDetail,
      dsTodo,
      userkefu,
      kefuCall,
      uploadScan,
      ncpKdlistConfirm,
      kefu,
      picker,
      mulPicScan
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/dialog/install.js